"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Events_1 = require("Core/Events");
var Cookies = require("js-cookie");
exports.ProductViewChanger = function () {
  var Selector = {
    ACCEPT_BTN: '.js_change_view'
  };
  Events_1.onClick(Selector.ACCEPT_BTN, changeView);
  function changeView() {
    var $target = $(this);
    var viewId = $target.data('view-id');
    Cookies.set('view', viewId);
    location.reload();
  }
}();